import { render } from "./Index.vue?vue&type=template&id=8f4ea460&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=8f4ea460&lang=less&scoped=true"
import "./Index.vue?vue&type=style&index=1&id=8f4ea460&lang=less"

import exportComponent from "E:\\project\\eyes-system\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f4ea460"]])

export default __exports__